module.exports = __webpack_public_path__ + "img/social-top.9dafbf7a.jpg";